import { C, fonts } from "../theme.js";

export const Footer = ({ accent }) => (
  <footer
    style={{
      borderTop: `1px solid ${accent}`,
      padding: "22px 40px",
      display: "flex",
      justifyContent: "space-between",
      fontFamily: fonts.mono,
      fontSize: 11,
      color: C.fainter,
      letterSpacing: "0.16em",
      background: C.bg,
    }}
  >
    <span>© 2026 PUNTA TECH · PUNTATECH.DEV</span>
    <span>MADRID, SPAIN</span>
  </footer>
);
